export enum EnLanguage {
  ptBR = 'ptBr',
  en = 'en'
}
